<template>
  <form class="inline" method="get">
    <div class="flex items-center shadow-xl bg-white rounded-3xl h-10 transition ease-in-out focus-within:border-green focus-within:border">
      <label for="sort-form" class="sr-only">Sort Results</label>
      <select
        name="sort"
        id="sort-form"
        v-model="selected"
        class="form-select ml-2 2xl:ml-4 pr-6 rounded-l-3xl"
      >
        <option value="date_listed|desc">Date Listed</option>
        <option value="list_price|desc">Price - high to low</option>
        <option value="list_price|asc">Price - low to high</option>
        <option value="date_modified|desc">Date Modified</option>
      </select>
      <button
        type="submit"
        class="form-button bg-blue-dark h-10 px-4 text-white flex items-center rounded-r-3xl"
        @click="submitForm($event)"
      >
        Sort
      </button>
    </div>
  </form>
</template>

<script>
export default {
  props: {
    fieldValue: {
      type: String,
      default: "date_listed|desc",
    },
    searchTerms: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      selected: this.fieldValue,
      formData: {
        omni: "",
        property_type: [],
        minPrice: "",
        maxPrice: "",
        beds: "",
        baths: "",
        sqft: "",
        acreage: "",
        status: ["Active", "Pending"],
        construction: [],
        is_waterview: false,
        is_waterfront: false,
        open_houses: false,
      },
      status: {
        active: true,
        sold: false,
        contingent: false,
        pending: true,
      },
    };
  },

  watch: {
    selected: {
      handler(val) {
        this.formData.sort = val;
      },
    },
  },

  mounted() {
    this.formData = this.searchTerms;

    if (this.searchTerms.sort !== null) {
      this.selected = this.searchTerms.sort;
    }
  },

  methods: {
    submitForm(event) {
      if (event) {
        event.preventDefault();
      }

      let vm = this;
      let route = "?q=search";

      Object.keys(this.formData).forEach((key) => {
        if (vm.formData[key] != undefined && vm.formData[key] != "") {
          if (Array.isArray(vm.formData[key])) {
            vm.formData[key].forEach((el) => {
              if (el != undefined && el != "") {
                route += "&" + key + "[]=" + el;
              }
            });
          } else {
            route += "&" + key + "=" + vm.formData[key];
          }
        }
      });

      window.location.href = route;
    },
  },
};
</script>
